(() => {
  const SELECTOR = '[data-amr-ros-carousel]';

  function initCarousel(root) {
    if (!root || root.__amrRosCarouselInit) return;
    root.__amrRosCarouselInit = true;

    const slides = Array.from(root.querySelectorAll('[data-amr-ros-slide]'));
    if (slides.length < 2) return;

    const intervalRaw = parseInt(root.getAttribute('data-interval') || '2000', 10);
    const interval = Number.isFinite(intervalRaw) && intervalRaw >= 500 ? intervalRaw : 2000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    let timer = null;

    function setActive(nextIndex) {
      index = ((nextIndex % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (reduceMotion) return;
      timer = window.setInterval(() => setActive(index + 1), interval);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    setActive(index);
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (evt) => {
    if (evt.target) initAll(evt.target);
  });
})();
